import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-viz-sequence',
  templateUrl: './viz-sequence.component.html',
  styleUrls: ['./viz-sequence.scss', '../viz-style.scss'],
})
export class VizSequenceComponent implements OnInit {
  @Input() data;
  @Input() layout;
  @Input() id: string;
  @Input() size;
  @Input() title;


  ngOnInit(): void {}

  setTextLayoutAutoBr(values) {
    let text = '';
    let j = 0;
    if (values.length) {
      for (j; j < values.length; j = j + 59) {
        text = text + values.slice(j, j + 59) + '<br>';
      }
    }
    return text;
  }
}
